<template>
    <table width="100%">
        <tbody>
            <tr style="background-color: #f5f5f5">
                <td colspan="2">
                    <strong>CONFIGURACIÓN DE FACTURACIÓN ELECTRÓNICA</strong>
                </td>
            </tr>

            <tr>
                <td>PROVEEDOR</td>
                <td>
                    <select class="form-control" v-model="localElectronica.proveedor">
                        <option value="">Seleccione...</option>
                        <option value="INTELLITECH">INTELLITECH</option> 
                        <option value="DIGITALSAS">SOFTWARE PROPIO</option> 
                    </select>
                </td>
            </tr>

            <tr>
                <td>URL</td>
                <td>
                    <input type="text" class="form-control" v-model="localElectronica.url">
                </td>
            </tr>

            <tr>
                <td>API KEY</td>
                <td>
                    <input type="text" class="form-control" v-model="localElectronica.apikey">
                </td>
            </tr>

            <tr>
                <td>USUARIO</td>
                <td>
                    <input type="text" class="form-control" v-model="localElectronica.usuario">
                </td>
            </tr>

            <tr>
                <td>CLAVE</td>
                <td>
                    <input type="password" class="form-control" v-model="localElectronica.clave">
                </td>
            </tr>

            <tr>
                <td>CORREO EMISOR</td>
                <td>
                    <input type="email" class="form-control" v-model="localElectronica.correo_emisor">
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "ElectronicaConfig",

    props: {
        electronica: {
            type: Object,
            required: true
        }
    },

    emits: ["update:electronica"],

    data() {
        return {
            localElectronica: JSON.parse(JSON.stringify(this.electronica))
        };
    },

    watch: {
        electronica: {
            immediate: true,
            deep: true,
            handler(value) {
                this.localElectronica = JSON.parse(JSON.stringify(value));
            }
        },

        localElectronica: {
            deep: true,
            handler(value) {
                this.$emit("update:electronica", JSON.parse(JSON.stringify(value)));
            }
        }
    }
};
</script>